import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import UserDropdown from "@core/layouts/components/profilecomponents/UserDropdown";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "mdi-material-ui/Menu";

import Storage from "@core/helper/Storage";
import { logOut } from "store/reducer/AuthReducer";
import LogoutModal from "@core/components/logoutmodal";

const AppBarContent = (props) => {
  const { settings, toggleNavVisibility, hidden, handleResetPassword } = props;
  const [logoutModal, setLogoutModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    setLogoutModal(true);
  };

  const confirmLogout = async () => {
    Storage.logOutUser();
    dispatch(logOut());
    await Storage.getUserData();

    navigate("/login");
    setLogoutModal(false);
  };

  const handleLogoutModal = () => {
    setLogoutModal(false);
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        className="actions-left"
        sx={{ mr: 2, display: "flex", alignItems: "center" }}
      >
        {hidden ? (
          <IconButton color="inherit" onClick={toggleNavVisibility}>
            <MenuIcon />
          </IconButton>
        ) : null}
      </Box>
      <Box
        className="actions-right"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <UserDropdown
          settings={settings}
          handleLogout={handleLogout}
          onClickPassword={handleResetPassword}
        />
      </Box>
      <LogoutModal
        open={logoutModal}
        handleClose={handleLogoutModal}
        handleLogout={confirmLogout}
      />
    </Box>
  );
};

export default AppBarContent;
